import { useState, useEffect } from "react";
import CustomButton from "../../components/CustomButton";
import '../../assets/css/CreateGame.css';
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Layout from "../../layouts/Layout";
import { saveCreateGameData } from "../../redux/UserDataSlice";
import PaymentModal from "../../components/PaymentModal";
import { RxCross2 } from "react-icons/rx";
import "../../assets/css/PlayerList.css";
import { IoIosArrowDropleft } from "react-icons/io";
import { HashLoader } from "react-spinners";
import CreateFormField from "./CreateFormField";

const CreateGame = () => {

    const { accessToken } = useSelector((state) => state.loginInfo);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [courtData, setCourtData] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({
        courtName: "",
        gameName: "",
        level: "",
        personsType: "More",
        numberOfPersons: "",
        dateTime: "",
        description: "",
        sportName: "",
        duration: "",
        zipCode: '',
        city: ''
    });

    useEffect(() => {
        dispatch(saveCreateGameData(null));
        setFormData({
            courtName: "",
            gameName: "",
            level: "",
            personsType: "MULTIPLAYER",
            numberOfPersons: null,
            dateTime: "",
            description: "",
            sportName: "",
            duration: "",
        });
    }, []);


    useEffect(() => {
        const fetchCourt = async () => {
            try {
                const result = await apiHandler({
                    url: endpoint.FETCH_COURT,
                    method: "GET",
                    authToken: accessToken?.accessToken
                });
                setLoader(true);
                if (!result?.data?.error) {
                    setCourtData(result?.data?.courts);
                    setLoader(false)
                } else {
                    setLoader(false)
                    toast.error("Something went wrong");
                }
            } catch (error) {
                console.error("Error fetching games:", error);
            }
        };

        fetchCourt();
    }, [])

    const onGoToBackPage = () => {
        navigate('/your-games');
    }

    const toggleModal = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            {!loader ?
                <Layout>
                    <div className="bg-sm-white create-game-wrapper p-3" style={{}}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="d-flex justify-content-start" >
                                <CustomButton className="back-page-btn" onClick={onGoToBackPage}
                                    buttonText={
                                        <> <IoIosArrowDropleft className="me-3" style={{ cursor: 'pointer', fontSize: '31px' }} /> Back</>
                                    }
                                />
                            </div>
                            <h4>Create Game</h4>
                            <div>
                            </div>
                        </div>

                        {/* Form Fields */}
                        <CreateFormField />

                    </div>
                    {isOpen &&
                        <div>
                            <div className={`modal-overlay ${isOpen ? "open" : "closeModal"}`} style={{ width: '100%', height: '500px' }}>
                                <div className="modal-content overflow-auto">
                                    <button onClick={toggleModal} className="close-button">
                                        <RxCross2 className='fs-4' />
                                    </button>
                                    <PaymentModal PaymentWay={'createGame'} />
                                </div>
                            </div>
                        </div>
                    }
                </Layout>
                :
                <div className="d-flex align-items-center justify-content-center" style={{ height: '55vh' }}>
                    < HashLoader color="#e48181" />
                </div>
            }
        </>
    );
};

export default CreateGame;